import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {NgbPaginationModule, NgbRatingModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';

import { HeaderModule} from '../../shared/header/header.module';
import { FooterModule} from '../../shared/footer/footer.module';
import { StreamNavModule} from '../../streams/stream-nav/stream-nav.module';
import { MembersTableModule} from '../../team/members-table/members-table.module';
import { BankTransferModule} from '../../user/bank-transfer/bank-transfer.module';
import { LoginModule} from '../../shared/transact-auth/transact-auth.module';

import { StreamDetailsComponent} from './stream-details.component';

import { FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import { faInfo, faInfoCircle, faStar, faStarHalfAlt, faSync, faTimes} from '@fortawesome/free-solid-svg-icons';
import { faStar as faStarO} from '@fortawesome/free-regular-svg-icons';
import { SocialSharingModule} from '../../shared/social-sharing/social-sharing.module';
import { PodcastModule} from '../../shared/podcast/podcast.module';
import { SearchInputModule} from '../../shared/search-input/search-input.module';
import { NoteViewModule} from '../../shared/note-view/note-view.module';
import { SubscriptionPlansModule } from '../../shared/subscribe-plans/subscribe-plans.module';
import { ImgLazyLoadingModule } from '../../shared/image-lazy-loading/image-lazy-loading.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NotdPartnersModalModule } from '../../shared/notd-partners-modal/notd-partners-modal.module';
import { StreamCreatorModalModule } from '../../shared/stream-creator-modal/stream-creator-modal.module';
import { StreamStatsModalModule } from '../../shared/stream-stats-modal/stream-stats-modal.module';
import { AlertMessageModule } from '../../shared/alert-message/alert-message.module';
import { ImageEditorModule } from '../../shared/image-editor/image-editor.module';
import { ConfirmationModalModule } from '../../shared/confirmation-modal/confirmaton-modal.module';

@NgModule({
    declarations: [ StreamDetailsComponent ],
    imports: [
        RouterModule.forChild([{ path: '', component: StreamDetailsComponent }]),
        CommonModule,
        HeaderModule,
        FooterModule,
        StreamNavModule,
        NgbRatingModule,
        NgbPaginationModule,
        NoteViewModule,
        MembersTableModule,
        BankTransferModule,
        FontAwesomeModule,
        LoginModule,
        SocialSharingModule,
        PodcastModule,
        SearchInputModule,
        SubscriptionPlansModule,
        ImgLazyLoadingModule,
        NgbTooltipModule,
        FormsModule,
        ReactiveFormsModule,
        NotdPartnersModalModule,
        StreamCreatorModalModule,
        StreamStatsModalModule,
        AlertMessageModule,
        ImageEditorModule,
        ConfirmationModalModule
    ],
    exports: [ StreamDetailsComponent ]
})

export class StreamDetailsModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faSync, faStar, faStarO, faTimes, faStarHalfAlt, faInfoCircle, faInfo);
  }
}
